import type { MailboxInfo } from 'owa-client-types';
import { getMailboxKeyForMailboxInfo } from 'owa-client-types';
import getCopilotResultsAccountState from './getCopilotResultsAccountState';
import getListViewStore from '../store/Store';
import { type TableQueryType } from '../store/schema/TableQuery';
import type { CopilotResultsTableQuery } from '../store/schema/CopilotResultsTableQuery';
import type CopilotResultsStatus from '../store/schema/CopilotResultsStatus';
import type TableView from '../store/schema/TableView';

export function isCopilotResultsTabVisible(mailboxInfo: MailboxInfo): boolean {
    const state = getCopilotResultsAccountState(mailboxInfo);
    if (!state.copilotResultsTableViewId) {
        return false;
    }
    // State is keyed by coprincipal account, so primary and archive/shared mailboxes share
    // one slot. Match against the originating mailbox so the tab disappears when navigating
    // to a sibling mailbox (e.g., In-Place Archive) where Copilot is unavailable.
    const tableView = getListViewStore().tableViews.get(state.copilotResultsTableViewId);
    const originMailboxInfo = (tableView?.tableQuery as CopilotResultsTableQuery | undefined)
        ?.mailboxInfo;
    return (
        !!originMailboxInfo &&
        getMailboxKeyForMailboxInfo(originMailboxInfo) === getMailboxKeyForMailboxInfo(mailboxInfo)
    );
}

export function getCopilotResultsTableViewId(mailboxInfo: MailboxInfo): string | undefined {
    return getCopilotResultsAccountState(mailboxInfo).copilotResultsTableViewId;
}

export function getCopilotResultsTableView(mailboxInfo: MailboxInfo): TableView | undefined {
    const id = getCopilotResultsAccountState(mailboxInfo).copilotResultsTableViewId;
    return id ? getListViewStore().tableViews.get(id) : undefined;
}

export function getCopilotResultsOriginTableViewId(mailboxInfo: MailboxInfo): string | undefined {
    return getCopilotResultsAccountState(mailboxInfo).copilotResultsOriginTableViewId;
}

export function getCopilotResultsStatus(mailboxInfo: MailboxInfo): CopilotResultsStatus {
    return getCopilotResultsAccountState(mailboxInfo).copilotResultsStatus;
}

export function getCopilotResultsConversationId(mailboxInfo: MailboxInfo): string | undefined {
    return getCopilotResultsAccountState(mailboxInfo).copilotResultsConversationId;
}

export function isSearchInterplay(mailboxInfo: MailboxInfo): boolean {
    const state = getCopilotResultsAccountState(mailboxInfo);
    if (!state.copilotResultsTableViewId || !state.copilotResultsOriginTableViewId) {
        return false;
    }
    return (
        getListViewStore().tableViews.get(state.copilotResultsOriginTableViewId)?.tableQuery
            .type === 1
    );
}
